<div class="rule-template-picker d-flex justify-between mb-4">
  @for (item of items; let i = $index; track i) {
    <div
      class="rule-template-picker__item position-relative p-2 p-xl-4 cursor-pointer d-flex align-items-center justify-content-center flex-column"
      [ngClass]="{ 'is-active': item.isActive ? true : item.isActive === undefined ? i === activeItem : false }"
      (click)="itemClick.emit({ item: item, index: i })"
      [style.width]="items?.length ? 100 / (items?.length || 0) + '%' : '0%'">
      <div class="title w-100">{{ item.title }}</div>
      <span class="d-none d-xl-flex justify-content-between flex-column flex-grow-1">
        <p class="mt-2 text-break">{{ item.description }}</p>
        <div class="image-wrapper">
          <img [src]="item.illustration" />
        </div>
      </span>
    </div>
  }
</div>
@if (isLoading) {
  <bn-web-ui-loading />
}
